import PropTypes from 'prop-types';
import {intlShape, injectIntl} from 'react-intl';
import React from 'react';
import events from 'lib/events';
import {testConnectSidebarEnabled} from 'features';

class SideBar extends React.Component {
  static propTypes = {
    user: PropTypes.object,
    dealer: PropTypes.object,
    intl: intlShape.isRequired,
  };

  state = {
    activeNavItemName: window.location.hash.length > 0 ? window.location.hash.substring(1) : 'customers',
    toggled: false,
    tcError: false,
  };

  componentDidMount() {
    // Subscribe to events
    this._eventPagechange = events.subscribe('page-change', this.pageChangeEvent);
    let loc = window.location.hash;

    events.subscribe('testconnect.hasErrors', e => {
      this.setState({
        tcError: e,
      });
    });

    if (loc.charAt(0) === '#') {
      loc = loc.substr(1);
      loc = loc.substr(0, loc.indexOf('/'));
    }
    this.pageChangeEvent({page: loc});
  }

  componentWillUnmount() {
    if (this._eventPagechange) {
      this._eventPagechange.remove();
    }
  }

  _eventPagechange = null;

  getNavItems = () => {
    let {formatMessage} = this.props.intl;

    return [
      {
        title: formatMessage({id: 'customer.analysis.title'}),
        link: '#customers',
        name: 'customers',
        iconClass: 'bl bl-profile',
        pages: ['customers', 'customer', 'analysis', 'analysis-edit'],
        reqUser: true,
      },
      {
        title: formatMessage({id: 'dashboard.title'}),
        link: '#dashboard',
        name: 'dashboard',
        iconClass: 'bl bl-dashboard',
        pages: ['dashboard'],
        //posPermissionRequired: true,  no IDM permission? Dashboard always visible?
        reqUser: true,
      },
      {
        title: formatMessage({id: 'reports.title'}),
        link: '#reports',
        name: 'reports',
        iconClass: 'bl bl-reports',
        pages: ['reports', 'report'],
        reqPermissions: 'isAdmin',
        posPermissionRequired: true,
        reqUser: true,
      },
      {
        title: formatMessage({id: 'preferences.title'}),
        link: '#settings',
        name: 'settings',
        iconClass: 'bl bl-preferences',
        pages: ['settings'],
        reqPermissions: 'isAdmin',
        reqUser: true,
      },
      {
        title: formatMessage({id: 'tools.title'}),
        link: '#tools',
        name: 'tools',
        iconClass: 'bl bl-tools',
        reqUser: true,
        pages: ['tools', 'tool'],
      },
      {
        title: formatMessage({id: 'encyclopedia.title'}),
        link: '#encyclopedia',
        name: 'encyclopedia',
        iconClass: 'bl bl-encyclopedia',
        pages: ['encyclopedia', 'encyclopediaArticle'],
        reqUser: true,
      },
      {
        title: formatMessage({id: 'support.title'}),
        link: '#support',
        name: 'support',
        iconClass: 'bl bl-help',
        pages: ['support', 'supportArticle'],
        reqUser: false,
      },
      {
        title: formatMessage({id: 'problem.report.title'}),
        name: 'reportBug',
        iconClass: 'bl bl-bug-report',
        reqUser: true,
        onClick: () => events.publish('bug-report'),
      },
    ];
  };

  checkPOSPermissionReports = () => {
    const {user, dealer} = this.props;

    if (dealer && dealer.CurrentPOSIntegration === 0) {
      return false;
    }

    if (user && user.isDealerAdmin) {
      return true;
    }

    if (user && user.isAdmin && dealer && dealer.managerDetailedReporting) {
      return true;
    }

    return !!(user && user.isTestStation && dealer && dealer.testerDetailedReporting);
  };

  pageChangeEvent = loc => {
    let matchingItems = this.getNavItems().filter(item => item.link && item.pages.indexOf(loc.page) !== -1);

    if (matchingItems.length) {
      this.setState({activeNavItemName: matchingItems[0].name, show: true});
    } else if (loc.page === 'none') {
      this.setState({activeNavItemName: null, show: true});
    } else {
      console.warn('Unknown page', loc);
    }
  };

  toggleSidebar = () => {
    this.setState({
      toggled: !this.state.toggled,
    });
  };

  openTcOverlay = () => {
    this.setState({
      showTcOverlay: !this.state.showTcOverlay,
    });
  };

  tcMouseover = () => {
    this.setState({
      toggled: false,
    });
  };

  render() {
    let self = this;

    let navItemElements = self.getNavItems().map((item, index) => {
      let itemIsActive = item.name === this.state.activeNavItemName;

      if (!self.props.user && item.reqUser) {
        return null;
      }
      let overrideIDMReport = false;

      if (self.props.user && item.title === 'Reports' && item.posPermissionRequired && this.checkPOSPermissionReports()) {
        overrideIDMReport = true;
      }
      //Check IDM permissions
      if (self.props.user && item.reqPermissions && !self.props.user[item.reqPermissions] && !overrideIDMReport) {
        return null;
      }

      return <li className={itemIsActive ? 'active' : ''} key={index} style={{cursor: 'pointer'}}>
        <a href={item.link} onClick={item.onClick} className={item.name}>
          <div className='item-icon-section'>
            <i className={item.iconClass + ' nav-item-icon'} title={item.title}/>
          </div>
          <h5 className='item-expanded-section'>
            {item.title}
          </h5>
        </a>
      </li>;
    });

    let beaker =
      <a className='tcBeaker' style={{cursor: 'pointer'}} onClick={this.props.toggleTcOverlay}>
        <img src={this.state.tcError ? '/Content/img/TCBeakerAlert.svg' : '/Content/img/TCBeaker.svg'} />
      </a>;

    return <div id='sidebar' onClick={this.toggleSidebar}
      className={'hidden-print ' + (!this.props.user ? 'login ' : '') + (this.state.toggled ? 'sidebar-expanded ' : 'sidebar-closed ')}>
      <ul className='nav-item-list'>
        {navItemElements}
      </ul>
      <div className='sidebar-remaining'>
        <div className='remaining-icon-section'/>
        <div className='remaining-expanded-section'>
          {this.state.toggled ?
            <i onClick={this.toggleSidebar} className='bl bl-right_arrow mobile-chev' /> :
            null}
        </div>

      </div>
      {testConnectSidebarEnabled ? beaker : null}
    </div>;
  }
}

export default injectIntl(SideBar);
